<template>
  <div style="padding: 0 10px" class="d">
    <Form layout="code,code_new,error,systemSource,inboundCode" @search="search"></Form>
    <WmsTable :isPagination="query"  :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall">
      <div slot="image" slot-scope="{ record }">
        <ImgPreviews :images="record.pics" v-if="record.pics"></ImgPreviews>
      </div>
      <div slot="createrName" slot-scope="{ text, record }">
        <el-input maxlength='450' v-model="record.dutyName" v-show="record.isEdit" style="width:120px"></el-input>
        <span v-show="!record.isEdit">{{ record.dutyName }}</span>
        <a @click="editCreater(record)" href="javascript:;" style="margin-left:10px;">{{ record.isEdit ? "保存" : "编辑"
        }}</a>
      </div>
      <div slot="action" slot-scope="record" class="actionbox">
        <el-button @click="print(record)" type="primary">打印批次包</el-button>
        <el-button @click="confir(record)" type="primary" v-if="record.record.abnormalType == 1"
          :disabled="record.record.status == 1">确认</el-button>
        <el-button @click="discard(record)" type="primary" v-if="record.record.abnormalType == 1"
          :disabled="record.record.status == 1">废弃</el-button>
        <el-button @click="toFind(record)" type="primary" v-if="record.record.abnormalType == 0"
          :disabled="record.record.status == 1"> 已找到 </el-button>
      </div>
    </WmsTable>
    <el-dialog title="确认数量" :visible.sync="confirShow">
      <el-form>
        <el-form-item label="发生异常件数：">{{ abnormalNum }}</el-form-item>
        <el-form-item label="请输入实际数量">
          <el-input maxlength='450' v-model="confirNum" placeholder="请输入实际数量" style="width: 200px"
            @focus="inputConfirNum"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="tips" class="tips">
        {{ confirNum > abnormalNum ? "实际件数不能大于发生异常件数" : "实际件数少于发生异常件数，确认后，剩余件数将作为丢件处理，请确认是否已找到货" }}
      </div>
      <div>
        <el-button type="primary" @click="find">确定</el-button>
        <el-button type="info" @click="confirShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Form from "@/views/abnormal/components/form";
import ImgPreviews from "@/components/ImgPreviews";
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/abnormal/warehouse/columns";
import { innerExceptionPage, deal, editAbnormalCreaterApi } from "@/apis/abnormal";
import { templatePrintByPkg } from "@/utils/print";

export default {
  name: "abnormal_warehouse",
  components: { Form, WmsTable, ImgPreviews },
  props: {},
  data() {
    return {
      columns,
      dataSource: [],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      confirShow: false,
      confirNum: 0,
      abnormalNum: '',
      tips: false,
      innerCode: 0,
      tipsInitial: true
    };
  },
  created() { },
  watch: {
    confirNum: {
      handler: function (newVal) {
        if (newVal != "" && Number(newVal) != this.abnormalNum && !this.tipsInitial) {
          this.tips = true;
        } else {
          this.tips = false;
        }
      },
    },
  },
  methods: {
    search(formInline) {
      this.formInline = formInline;
      this.query.current = 1
      this.getdataSource();
    },
    discard(record) {
      let params = {
        innerCode: record.record.innerCode,
        tag: 2,
      };
      deal(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.getdataSource();
        }
      });
    },
    print(record) {
      if (record.record.pkgCodeNew) {
        let data = [{ ...record.record, pkgCode: record.record.pkgCodeNew }]
        this.$wmsPrint.print().templatePrintByPkg(data)
      }else{
        this.$message.warning('无新批次包')
      }
    },
    confir(record) {
      let params = {
        innerCode: record.record.innerCode,
        tag: 1,
      };
      deal(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.getdataSource();
        }
      });
    },
    toFind(record) {
      this.innerCode = record.record.innerCode;
      this.abnormalNum = record.record.abnormalAmount;
      this.confirShow = true;
      this.confirNum = ''
    },
    inputConfirNum() {
      this.tipsInitial = false
    },
    find() {
      let params = {
        innerCode: this.innerCode,
        backAmount: this.confirNum,
      };
      if (this.confirNum > this.abnormalNum) {
        this.$message.error("实际件数不能大于发生异常件数");
        return false;
      } else if (this.confirNum == this.abnormalNum) {
        deal(params).then(({ code, data }) => {
          if (code === 0) {
            this.$message.success("成功");
            this.getdataSource();
            this.confirShow = false;
          }
        });
      } else {
        this.$confirm("操作确认后，将剩余小于的数量，生成丢件批次包信息，在丢件列表展示，同时给业务系统回传异常补采采购单信息", "删除提示", {
          confirmButtonText: "确认",
          type: "error",
          cancelButtonText: "取消",
        }).then(() => {
          deal(params).then(({ code, data }) => {
            if (code === 0) {
              this.$message.success("成功");
              this.getdataSource();
              this.confirShow = false;
            }
          });
        });
      }
    },
    getdataSource() {
      let params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      innerExceptionPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getdataSource();
    },
    //修改责任人
    editCreater(record) {
      if (!record.createrName && record.isEdit) {
        return;
      }
      if (record.isEdit) {
        editAbnormalCreaterApi({
          dutyName: record.dutyName,
          innerCode: record.innerCode,
        }).then(() => {
          this.$message.success("操作成功！");
          this.$set(record, "isEdit", !record.isEdit);
        });
      } else {
        this.$set(record, "isEdit", !record.isEdit);
      }
    },
  },
};
</script>

<style scoped>
.d ::v-deep.el-form-item__content {
  text-align: left;
}

.actionbox {
  display: flex;
  align-items: center;
  color: #008dde;
}

.actionbox div {
  margin-left: 10px;
  color: #008dde;
}

.tips {
  text-align: left;
  color: red;
}
</style>
